import DemoNavbar from "components/Navbars/DemoNavbar";
import Sidebar from "components/Sidebar/Sidebar";
import { routes } from "../../routes/routes";
import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import imgPrincipal from "../../assets/avantSolar/SobreNosotros/somos_r4.jpg";
import Footer from "components/Footer/Footer";
import { useLocation } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import { Helmet } from "react-helmet-async";

var ps;
function SobreNosotros(props) {
  const [image, setImage] = useState(imgPrincipal);
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current, {
      suppressScrollX: true, // Disable horizontal scrollbar
    });
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Quienes Somos</title>
        <meta
          name="description"
          content="Avantsolar es una empresa líder en la promoción y construcción ..."
        />
        <meta name="robots" content="all" />
      </Helmet>
      <div className="wrapper">
        <Sidebar {...props} routes={routes} />
        <div className="main-panel h-100" ref={mainPanel}>
          <div>
            <DemoNavbar {...props} hideTitle />
            <Row>
              <Col xs={12} sm={6} md={5} xl={5} className=" p-0 fondoColumna">
                <div className="linea1 helpHeaderLine">
                  <Row>
                    <Col xs={1}>
                      <div className="linea2 h-100 p-3"></div>
                    </Col>
                    <Col>
                      <div className="d-flex justify-content-center flex-column align-items-center p-2">
                        <h1 className="p-0 m-0 h4 font-weight-bold">
                          QUIENES SOMOS
                        </h1>
                        <p className="p-0 m-0 text-light h6">NUESTRO EQUIPO</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="p-5">
                  <p className="font-weight-bold">
                    Ingenieria Avanzada Solar S.L.
                  </p>
                  <ul>
                    <li>Ingeniería y desarrollo - Administración</li>
                    <li>
                      Calle de Núñez de Balboa, 120, 28006 Madrid Tel: 93 530 94 17 Fax: 93 376 45 37
                    </li>
                  </ul>

                  <p className="font-weight-bold">Taller Mecánico - Fabricación estructuras</p>
                  <ul>
                    <li>
                      Calle Bailen 71 23600 Martos (Jaén) Tel y Fax: 953 900
                      009
                    </li>
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={6} md={7} xl={7} className="p-0">
                <div className="linea1 helpHeaderLine d-none d-sm-block"></div>
                <div className="p-5 d-flex justify-content-center">
                  <img
                    draggable="false"
                    className="imgSeguidores"
                    src={image}
                  ></img>
                </div>
              </Col>
            </Row>

            <Row className="p-2">
              <Col xs={12} sm={6} className="px-5 mt-5">
                <p className="font-weight-bold">Trayectoria</p>
                <ul className="mt-3">
                  <li>
                    Avantsolar es una empresa líder en la promoción y
                    construcción de huertas solares, inciando su actividad en
                    2005
                  </li>
                  <li>
                    Nos esforzamos por encontrar ubicaciones con la máxima
                    radiación para maximizar la rentabilidad que ofrecemos a
                    nuestros clientes.
                  </li>
                  <li>Más de 10MW tramitados e instalados nos avalan.</li>
                </ul>
                <hr />
                <p className="font-weight-bold">Ingeniería</p>
                <ul className="mt-3">
                  <li>
                    Avantsolar es una empresa líder en la promoción y
                    construcción de huertas solares, inciando su actividad en
                    2005
                  </li>
                  <li>
                    Nos esforzamos por encontrar ubicaciones con la máxima
                    radiación para maximizar la rentabilidad que ofrecemos a
                    nuestros clientes.
                  </li>
                  <li>Más de 10MW tramitados e instalados nos avalan.</li>
                </ul>
              </Col>

              <Col xs={12} sm={6} className="px-5 mt-5">
                <p className="font-weight-bold">Taller mecánico</p>
                <ul className="mt-3">
                  <li>
                    Fabricamos la máquina que mejor se ajusta a las necesidades
                    del proyecto
                  </li>
                  <li>Alta calidad en todo el proceso de fabricación.</li>
                  <li>
                    Nuestros técnicos solucionan cualquier incidencia de forma
                    rápida y eficaz.
                  </li>
                </ul>
                <hr />
                <p className="font-weight-bold">Colaboradores</p>
                <ul className="mt-3">
                  <li>
                    Trabajamos con los mejores proveedores, tanto nacionales
                    como internacionales
                  </li>
                  <li>
                    Nuestras instalaciones cuentan con materiales de primeros
                    fabricantes, utilizando sólo módulos fotovoltaicos de origen
                    Europeo, Japonés o Norteamericano.
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default SobreNosotros;
